module Meevo.Plugins.Manufacturers {
  "use strict";

  /**
  * Main Section of Manufacturer 
  */
  export class NotesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Manufacturer> {

  }

}